<template>
  <div class="grid_row">
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-form ref="create_cn" @submit.prevent="create_cn">
        <v-card>
          <div class="pa-4">
            <div class="grid_half">
              <div class="grid_list">
                <div class="mt-4 ml-1 mr-1">
                  <div class="mb-2">เลขที่ใบส่งคืนสินค้า</div>
                  <div class="pl-3 pt-1 grey--text">{{ header_list.receipt_no }}</div>
                </div>
                <div class="mt-4 ml-1 mr-1">
                  <div class="mb-2">วิธีการแก้ไข</div>
                  <div class="pl-3 pt-1 grey--text">{{ header_list.return_edit_text }}</div>
                </div>
              </div>
            </div>
            <div class="grid_half">
              <div class="grid_list">
                <div class="mt-4 ml-1 mr-1">
                  <div class="mb-2">เลขที่ใบส่งลดหนี้ (CN)</div>
                  <div class="pl-3 pt-1 grey--text">{{ header_list.cn_number }}</div>
                </div>
                <div class="mt-4 ml-1 mr-1">
                  <div class="mb-2">วันที่ส่งคืนสินค้า</div>
                  <div class="pl-3 pt-1 grey--text">{{ date }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="Pr_List" :items="data_list" key="index" :items-per-page="item_page" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
              <template v-slot:item="dataDetail" >
                <tr>
                  <td class="pa-3">{{ dataDetail.index + 1 }}</td>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td>{{ dataDetail.item.lot_no }}</td>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>{{ dataDetail.item.unit }}</td>
                  <td>{{ diffPosition(dataDetail.item.date_expired) }}</td>
                  <td>{{ format_number(dataDetail.item.quantity) }}</td>
                  <td>{{ format_price(dataDetail.item.price) }}</td>
                  <td>{{ format_price(dataDetail.item.quantity * dataDetail.item.price) }}</td>
                  <td>
                    <div class="text-center" v-if="dataDetail.item.exchange_status !== 0">รอคืน</div>
                    <div class="text-center" v-else>-</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {
  diffChangeFormat,
  diffChangePosition,
  diffDateTH,
  formatNumber,
  formatPrice,
  onlyForCurrency,
  onlyForNumber
} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "StorageCN_detail",
  data() {
    return {
      search: null,
      loading_page: false,
      date: '',
      dateEN: '',
      menu_date: false,
      start_date: null,
      alert_success: false,
      alert_danger: false,
      doc_no: null,
      pro_id: null,
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      Pr_List: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '95px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '130px',
        },
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '180px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่หมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          fixed: true,
          width: '180px',
        },
        {
          text: 'สินค้ารอคืน',
          value: 'exchange_status',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      supplier_list: [],
      header_list: [],
      product_list: [],
      data_list: [],
      unit_list: [],
      loop_id: 0,
    }
  },
  methods: {
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDate_Change: function(value) {
      return diffChangeFormat(value)
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    diffPosition: function(value) {
      return diffChangePosition(value)
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    diffDate: function(value) {
      return diffDateTH(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('imports/cn/getcnbyid', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.cn_head
          this.data_list = res.data.cn_lists
          if (res.data.cn_head.receipt_date !== null) {
            this.date = res.data.cn_head.receipt_date
            this.diffDate_TH(this.date)
          }
          else {
            this.date = '-'
          }
        }
      })
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_row {
  display: grid;
  grid-template-columns: 100%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.text_return {
  margin-top: 27px;
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .text_return {
    margin-top: 15px;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
